import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { RouterState, Router } from '@angular/router';
import { Credentials } from '../../domain/credentials';
import { AuthorisationService } from '../../services/authorisation-service/authorisation-service.service';
import { RegistrationModel } from '../../models/registration-model';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { LoggingService } from '../../services/logging-service/logging.service';
import { FormsModule } from '@angular/forms';
import { FieldMatchErrorMatcher } from '../../shared/field-match.directive';
import { UserSessionService } from '../../services/user-session-service/user-session.service';



@Component({
  selector: 'app-portal-registration-view',
  templateUrl: './portal-registration-view.component.html',
  styleUrls: ['./portal-registration-view.component.css']
})
export class PortalRegistrationViewComponent implements OnInit {

  registrationModel: RegistrationModel;
  attemptingRegistration: boolean;
  registrationFailed: boolean;
  registrationToken: string;
  generalError: boolean;
  resetPassword: boolean;
  emailAddress: string;
  fieldMatchErrorMatcher = new FieldMatchErrorMatcher();

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private authorisationService:
      AuthorisationService, private loggingService: LoggingService, private snackBar: MatSnackBar,
    private userSessionService: UserSessionService) { }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSessionService.checkRoute(this.router.url);
    this.shellUpdateService
      .sendShellUpdateMessage(new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Registration', null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, false, false, true));
    this.registrationModel = new RegistrationModel();

    this.router.routerState.root.queryParams.subscribe((params) => {
      this.registrationToken = params['token'];
      this.registrationModel.EmailAddress = params['email'];
    });
  }

  // Validate the token with the API
  register() {
    this.attemptingRegistration = true;
    this.registrationModel.Token = this.registrationToken;
    this.authorisationService.register(this.registrationModel).subscribe((response) => {

      // Everything ok
      this.loggingService.log('Registration completed successfully', this.appConfigService.LogToConsole);
      const snackbarRef = this.snackBar.open(`Registration completed successfully. Please log-in`, 'Login', { duration: 3000 });
      snackbarRef.onAction().subscribe((action) => {
        this.router.navigate(['app', 'login']);
      });
      snackbarRef.afterDismissed().subscribe((action) => {
        this.router.navigate(['app', 'login']);
      });
    }, (error) => {
      const httpErrorResponse = error as HttpErrorResponse;
      let snackbarRef;
      switch (httpErrorResponse.status) {
        case 400:
          this.loggingService.log('One or more paramters used for registration are invalid', this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open('Sorry, something went wrong. Please check your details and try again.', '', { duration: 5000 });
          this.attemptingRegistration = false;
          break;
        case 500:
          this.loggingService.log('Server error during registration', this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open('Sorry, something went wrong. Server Error.', '', { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
        case 403:
          this.loggingService.log('Registration failed. Your details may be incorrect', this.appConfigService.LogToConsole);
          snackbarRef =
            this.snackBar.open('Verification failed. Please contact your NHS Trust and ask them to re-authorise.', '', { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
        default:
          this.loggingService.log('Server could not be contacted', this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open('Server unavailable. Please try again later.', '', { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
      }
    });
  }

  redirectToHome() {
    this.router.navigate(['app', 'welcome']);
  }
}





// WEBPACK FOOTER //
// ./src/app/views/portal-registration-view/portal-registration-view.component.ts